export const seoGuideApiToSectionsFormat = apiFormat => {
  return {
    settingUp: {
      installAnalytics: apiFormat.installAnalytics,
      installSearchConsole: apiFormat.installSearchConsole,
      linkSearchConsole: apiFormat.linkSearchConsole,
      domainAge: apiFormat.domainAge,
      robotsTxt: apiFormat.robotsTxt,
      sitemapXml: apiFormat.sitemapXml
    },
    research: {
      selecting: apiFormat.selecting,
      analyzing: apiFormat.analyzing,
      firstList: apiFormat.firstList
    },
    onPage: {
      structuring: apiFormat.structuring,
      optimizedUrls: apiFormat.optimizedUrls,
      removeDuplicates: apiFormat.removeDuplicates,
      uniqueTitles: apiFormat.uniqueTitles,
      uniqueMeta: apiFormat.uniqueMeta,
      headings: apiFormat.headings,
      altTags: apiFormat.altTags,
      brokenLinks: apiFormat.brokenLinks,
      speed: apiFormat.speed,
      outboundLinks: apiFormat.outboundLinks,
      crossLinking: apiFormat.crossLinking,
      redirects: apiFormat.redirects,
      validity: apiFormat.validity
    },
    contentStrategy: {
      niche: apiFormat.niche,
      writing: apiFormat.writing,
      optimizedContent: apiFormat.optimizedContent,
      blog: apiFormat.blog,
      otherMedia: apiFormat.otherMedia,
      contributors: apiFormat.contributors,
      otherContent: apiFormat.otherContent
    },
    offPage: {
      check: apiFormat.check,
      quality: apiFormat.quality,
      collaborate: apiFormat.collaborate,
      discussion: apiFormat.discussion
    },
    social: {
      worth: apiFormat.worth
    }
  }
}
